import { actionTypes } from '../actions/pricing';
import { pricing as defaultState } from './default.json';

const handlers = {
  [actionTypes.PRICING_GET_ERROR]: (state, action) => ({
    ...state,
    error: action.error.message,
    inProgress: false,
  }),
  [actionTypes.PRICING_GET_IN_PROGRESS]: state => ({
    ...state,
    error: null,
    inProgress: true,
  }),
  [actionTypes.PRICING_GET_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    inProgress: false,
    results: {
      ...action.results,
    },
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
